import script from "./GalleryDetailTopHeadSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryDetailTopHeadSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./GalleryDetailTopHeadSkeleton.vue?vue&type=style&index=0&id=7e1816cf&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e1816cf"]])

export default __exports__